import { getElementByQuery, getElementsByQuery, getSiblingByQuery, isNullOrUndefined, toggleCssClass } from '../../../general/js/general-helpers';
import { getIsOneClubMemberFromCookie } from '../../sso/components/utils/user-data-cookie/user-data-cookie-helpers';
import { rightHeaderLinksConstants } from './right-header-link-item-constants';

export const displayRightHeaderLinkByOneClubMembership = (container = document) => {
    const isOneClubMember = getIsOneClubMemberFromCookie();
    const mainRightHeaderLinkItem = getMainRightLinkItem(container);
    const memberRightHeaderLinkItem = getMemberRightLinkItem(container);

    toggleRightHeaderLink(isOneClubMember, mainRightHeaderLinkItem, memberRightHeaderLinkItem);
}

export const toggleRightHeaderLink = (isOneClubMember = false, mainRightHeaderLinkItem = null, memberRightHeaderLinkItem = null) => {
    if(isNullOrUndefined(mainRightHeaderLinkItem)){
        return;
    }

    const displayMemberLinkItemCondition = isOneClubMember && !isNullOrUndefined(memberRightHeaderLinkItem);
    
    toggleCssClass(mainRightHeaderLinkItem, rightHeaderLinksConstants.HIDDEN_CLASS, displayMemberLinkItemCondition);
    toggleCssClass(memberRightHeaderLinkItem, rightHeaderLinksConstants.HIDDEN_CLASS, !displayMemberLinkItemCondition);
}

export const getMainRightLinkItem = (container = document) => {
    return getElementByQuery(`.${rightHeaderLinksConstants.RIGHT_NAV_TITLE_CLASS}`,{ rightHeaderLinkItem: [container] });
}

export const getMemberRightLinkItem = (container = document) => {
    return getElementByQuery(`.${rightHeaderLinksConstants.MEMBER_RIGHT_NAV_TITLE_CLASS}`,{ rightHeaderLinkItem: [container] });
}

export const getAllMainRightLinkItems = (container = document) => {
    return getElementsByQuery(`.${rightHeaderLinksConstants.TOP_NAV_LINK_RIGHT_CLASS} .${rightHeaderLinksConstants.RIGHT_NAV_TITLE_CLASS}`,{ rightHeaderLinkItem: [container] });
}

export const getSiblingMemberRightLinkItem = (element = null) => {
    if (isNullOrUndefined(element)){
        return null;
    }

    return getSiblingByQuery(`.${rightHeaderLinksConstants.MEMBER_RIGHT_NAV_TITLE_CLASS}`, element);
}
